namespace $ {

	$mol_style_define( $bog_max_nav, {
		flex: { direction: 'row', grow: 1 },
		justify: { content: 'center' },
		padding: { top: '0.375rem', bottom: '0.375rem', left: '0.5rem', right: '0.5rem' },
		gap: '0.25rem',
		background: { color: $mol_theme.card },
		border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
	})

}
